module.exports = __webpack_public_path__ + "static/media/clinical_invite_icon.ebdb801f.svg";